module.exports = __webpack_public_path__ + "img/jiangxiang.befe88a4.png";